import React, { FC, ReactNode } from 'react'
import { TabWrapper } from './Tab.styled'

type TabProps = {
    show: boolean;
    children: ReactNode;
}

export const Tab: FC<TabProps> = ({ show, children }) => {
  return (
    <TabWrapper className={show ? "" : "hidden"}>{children}</TabWrapper>
  )
}
